<template>
  <div class="dashboard-container">
    <Operate
      v-if="dialog.refresh"
      :dialog.sync="dialog.show"
      :row="dialog.row"
      :info="dialog.info"
      @get-list="getList"
      @refresh="refreshDialog"
    />
    <ViewAccount
      v-if="dialog.refresh2"
      :dialog.sync="dialog.show2"
      :row="dialog.row"
      :info="dialog.info"
      @refresh="refreshDialog"
    />
    <AddMaster
      v-if="addMaster.refresh"
      :dialog.sync="addMaster.show"
      :row="addMaster.row"
      :info="addMaster.info"
      @get-list="getList"
      @refresh="refreshDialog"
    />
    <el-card>
      <el-row type="flex" justify="space-between" :gutter="50">
        <el-col>
          <el-input v-model="condition.search" class="input searchInput" size="mini" suffix-icon="el-icon-search" placeholder="搜索" @input="searchInput" />
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px;">
      <el-row>
        <vxe-toolbar>
          <template v-slot:buttons>
            <el-row type="flex" justify="between">
              <el-col v-if="$loginInfo.role_g_id!=3">
                <el-button type="primary" size="mini" @click="openDialog({title:'添加账号',addOr:'add'})">添加账号</el-button>
                <el-button type="danger" size="mini" @click="remove({del:'batch'})">批量删除</el-button>
              </el-col>
              <el-col v-else>
                <el-button type="primary" size="mini" @click="openMaster({title:'添加管理员账号',addOr:'add'},{company_id:$loginInfo.company_id})">添加管理员账号</el-button>
              </el-col>
              <el-col :span="1">
                <vxe-button @click="getList">刷新</vxe-button>
              </el-col>
            </el-row>
          </template>
        </vxe-toolbar>
        <vxe-table
          ref="table"
          border
          resizable
          :auto-resize="true"
          :header-row-style="headerStyle"
          :row-style="rowStyle"
          align="center"
          class="vxe-table-element"
          height="600"
          row-id="job_id"
          :sort-config="{remote: true}"
          :filter-config="{remote: true}"
          :checkbox-config="{reserve: true}"
          :data="table.list"
          :loading="loading"
        >
          <template>
            <vxe-table-column type="checkbox" width="60" fixed="left" />
            <vxe-table-column type="seq" width="60" />
            <vxe-table-column
              field="user_name"
              title="用户名称"
            />
            <vxe-table-column
              field="login_name"
              title="登录名"
            />
            <vxe-table-column
              v-if="$loginInfo.role_g_id!=3"
              field="email"
              title="邮箱"
            />
            <vxe-table-column
              v-if="$loginInfo.role_g_id==3"
              field="dept_name"
              title="所属组织"
            />
            <vxe-table-column
              v-if="$loginInfo.role_g_id==3"
              field="identity_name"
              title="所属角色"
            />
            <vxe-table-column
              field="telephone"
              title="手机号"
            />
            <vxe-table-column
              v-if="$loginInfo.role_g_id!=3"
              field="region_name"
              title="所属地区"
            />
            <vxe-table-column
              v-if="$loginInfo.role_g_id==3"
              field="create_time"
              title="创建时间"
            />
          </template>
          <vxe-table-column field="" title="操作">
            <template v-slot="{ row, rowIndex }">
              <el-dropdown size="small" type="primary">
                <el-button size="small" type="primary">
                  操作<i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <template v-if="$loginInfo.role_g_id!=3">
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" @click.native="openDialog({title:'修改账号',addOr:'upd'},row)">修改</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-user" @click.native="openView({title:'子账号列表'},row)">子账号</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" @click.native="remove({del:'single'},row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
                <template v-else>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" @click.native="openMaster({title:'修改账号',addOr:'upd'},row)">修改</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" @click.native="remove({del:'single'},row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div style="height: 20px" />
        <el-pagination
          background
          :current-page="table.currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100]"
          :page-size="table.pageSize"
          layout="total, ->, sizes, prev, pager, next, jumper"
          :total="table.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import { rowStyle, headerStyle } from '@/utils/tableStyleJs'
  import { getMaster, deleteMaster } from '@/api/master'
  import { getMasterByCom } from '@/api/dept'
  import Operate from './Operate'
  import ViewAccount from './ViewAccount'
  import AddMaster from './AddMaster'
  export default {
    name: 'Index',
    components: {
      Operate,
      ViewAccount,
      AddMaster
    },
    data() {
      return {
        loading: false,
        condition: {
          search: ''
        },
        table: {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          sortName: '',
          sortBy: ''
        },
        dialog: {
          row: Object,
          info: {},
          refresh: false, // 每次刷新DOM
          show: false,
          refresh2: false, // 每次刷新DOM
          show2: false
        },
        addMaster: {
          row: Object,
          info: {},
          refresh: false, // 每次刷新DOM
          show: false
        }
      }
    },
    created() {
      this.getList()
    },
    methods: {
      rowStyle,
      headerStyle,
      // 打开dialog
      openDialog(info, row) {
        this.dialog.refresh = true
        this.dialog.show = true
        this.dialog.info = info
        this.dialog.row = row
      },
      // 打开dialog
      openView(info, row) {
        this.dialog.refresh2 = true
        this.dialog.show2 = true
        this.dialog.info = info
        this.dialog.row = row
      },
      // 打开dialog
      openMaster(info, row) {
        this.addMaster.refresh = true
        this.addMaster.show = true
        this.addMaster.info = info
        this.addMaster.row = row
      },
      searchInput(v) {
        this.getList()
      },
      changeCondition() {
        this.getList()
      },
      getList() {
        this.loading = true
        if (this.$loginInfo.role_g_id != 3) {
          getMaster({
            role_g_id: 3,
            master_level: this.$loginInfo.master_level,
            searchName: this.condition.search,
            currentPage: this.table.currentPage,
            pageSize: this.table.pageSize
          }).then(res => {
            if (res.data.code === 1) {
              this.table.list = res.data.content
              this.table.total = Number(res.data.totalElements)
            }
            this.loading = false
          }).catch(e => {
            this.loading = false
          })
        } else {
          getMasterByCom({
            identity_name: this.condition.search,
            company_id: this.$loginInfo.company_id,
            p_id: this.$loginInfo.master_id,
            currentPage: this.table.currentPage,
            pageSize: this.table.pageSize
          }).then(res => {
            if (res.data.code === 1) {
              this.table.list = res.data.content
              this.table.total = Number(res.data.totalElements)
            }
            this.loading = false
          }).catch(e => {
            this.loading = false
          })
        }
      },
      remove(info, row) {
        const id = []
        if (info.del === 'batch') {
          const arr = this.$refs.table.getCheckboxRecords()
          const arr1 = this.$refs.table.getCheckboxReserveRecords()
          const batchDel = arr.concat(arr1)
          for (const i of batchDel) {
            id.push(i.master_id)
          }
          if (id.length === 0) {
            this.$message.error('请勾选！！！')
            return
          }
        } else {
          id.push(row.master_id)
        }
        const a = ac => {
          if (ac === 'confirm') {
            deleteMaster(null, {
              master_id: id.join()
            }).then(res => {
              if (res.data.code === 1) {
                this.$message.success(res.data.msg)
                this.$refs.table.clearCheckboxRow()
                this.$refs.table.clearCheckboxReserve()
                this.getList()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else {
            this.$message.info('取消了删除！！！')
          }
        }
        this.$topicMsg('确认删除吗！！！', a)
      },
      handleSizeChange(pageSize) {
        this.table.pageSize = pageSize
        this.table.currentPage = 1
        this.getList()
      },
      handleCurrentChange(currentPage) {
        this.table.currentPage = currentPage
        this.getList()
      },
      refreshDialog() {
        this.dialog.refresh = false
        this.dialog.refresh2 = false
        this.addMaster.refresh = false
      }
    }
  }
</script>

<style scoped>

</style>
